// АВ.1: каталог пользовательских аватаров.
// id — совпадает с player_cosmetics.cosmetic_id на сервере.
// glitchColor — оттенок RGB-сдвига при глитч-эффекте (CSS hex).
//
// Новые аватары добавляем сюда же. Если эффект не нужен — glitchColor=null
// (UserAvatar нарисует без RGB-сдвига, только базовая картинка).

export interface AvatarMeta {
  id: string;
  label: string;
  src: string;          // путь от /public
  glitchColor: string | null;
}

export const AVATAR_CATALOG: Record<string, AvatarMeta> = {
  ava_male: {
    id: 'ava_male',
    label: 'Стандарт-М',
    src: '/img/avatars/ava_male.webp',
    glitchColor: '#FF3D3D'   // красный — под цвет самой картинки
  },
  // УР.1: награда за достижение уровня 100. Картинку пришлёт юзер;
  // до этого UserAvatar отрендерит SVG-плейсхолдер с золотым контуром.
  ava_lvl100: {
    id: 'ava_lvl100',
    label: 'Легенда 100',
    src: '/img/avatars/ava_lvl100.webp',
    glitchColor: '#FFB13D'   // золото — для legendary-эффекта
  }
};

export function getAvatarMeta(id: string | null | undefined): AvatarMeta | null {
  if (!id) return null;
  return AVATAR_CATALOG[id] || null;
}
